import React, { useEffect, useState, useRef, useContext, useMemo, useCallback } from 'react';
import { Row, Col, Tooltip, } from 'reactstrap';
import DayTime from '../../../common/DayTimeWrapper'
import { defaultPageSize, EMPTY_DATA, CBCTypeId, EXCHNAGERATE, RMIMPORT, ZBCTypeId, VBCTypeId } from '../../../../config/constants';
import NoContentFound from '../../../common/NoContentFound';
import { checkForDecimalAndNull, checkForNull, getConfigurationKey, loggedInUserId, searchNocontentFilter, showBopLabel, preciseAdd, preciseSubtract, preciseMultiply, preciseDivide } from '../../../../helper';
import Toaster from '../../../common/Toaster';
import { runVerifyBoughtOutPartSimulation } from '../../actions/Simulation';
import { Fragment } from 'react';
import { TextFieldHookForm } from '../../../layout/HookFormInputs';
import { useForm, Controller } from 'react-hook-form'
import RunSimulationDrawer from '../RunSimulationDrawer';
import VerifySimulation from '../VerifySimulation';
import { useDispatch, useSelector } from 'react-redux';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import Simulation from '../Simulation';
import { debounce } from 'lodash'
import { PaginationWrapper } from '../../../common/commonPagination';
import DatePicker from "react-datepicker";
import WarningMessage from '../../../common/WarningMessage';
import { getMaxDate } from '../../SimulationUtils';
import ReactExport from 'react-export-excel';
import { BOP_IMPACT_DOWNLOAD_EXCEL_NON_ASSOCIATED } from '../../../../config/masterData';
import { reactLocalStorage } from 'reactjs-localstorage';
import { simulationContext } from '..';
import LoaderCustom from '../../../common/LoaderCustom';
import { useLabels } from '../../../../helper/core';
import AddConditionCosting from '../../../costing/components/CostingHeadCosts/AdditionalOtherCost/AddConditionCosting';
import AddOtherCostDrawer from '../../../masters/material-master/AddOtherCostDrawer';
import { parsedDate, updateCostValue } from '../../../common/CommonFunctions';
import { createMultipleExchangeRate } from '../../../masters/actions/ExchangeRateMaster';
import { beforeSaveCell as validateRevisedRate, validateAndFormatValue, resetFieldToLastValidValue, valueSetter } from '../../../../helper/simulationValidation';
import PriceComparisonSpan from '../../../common/PriceComparisonSpan';
import { useSimulationUndo, useSimulationGrid, useSimulationVBC } from '../../../../hooks/simulation';
import UndoButton from '../common/UndoButton';
import RedoButton from '../common/RedoButton';

const gridOptions = {

};

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function BDNonAssociatedSimulation(props) {
    const { showEditMaster, handleEditMasterPage, showCompressedColumns, render } = useContext(simulationContext) || {};
    const { vendorLabel } = useLabels()
    const { list, isbulkUpload, rowCount, tokenForMultiSimulation } = props
    const isImpactedMaster = props?.isImpactedMaster; // <-- add this line
    const [showRunSimulationDrawer, setShowRunSimulationDrawer] = useState(false)
    const [showverifyPage, setShowVerifyPage] = useState(false)
    const [token, setToken] = useState('')
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const gridRef = useRef();
    const [isDisable, setIsDisable] = useState(false)
    const [effectiveDate, setEffectiveDate] = useState('');
    const [isEffectiveDateSelected, setIsEffectiveDateSelected] = useState(false);
    const [isWarningMessageShow, setIsWarningMessageShow] = useState(false);
    const [titleObj, setTitleObj] = useState({})
    const [maxDate, setMaxDate] = useState('');
    const [noData, setNoData] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false)
    const [basicRateviewTooltip, setBasicRateViewTooltip] = useState(false)
    const [rowData, setRowData] = useState([])
    const [basicRate, setBasicRate] = useState('')
    const [netCostWithoutConditionCost, setNetCostWithoutConditionCost] = useState('')
    const [openOtherCostDrawer, setOpenOtherCostDrawer] = useState(false)
    const [openConditionCostDrawer, setOpenConditionCostDrawer] = useState(false)
    const [otherCostDetailForRow, setOtherCostDetailForRow] = useState([])
    const [conditionCostDetailForRow, setConditionCostDetailForRow] = useState([])

    const [rowIndex, setRowIndex] = useState('')
    const [editRowId, setEditRowId] = useState('') // CRITICAL: Store ID instead of index
    const [shouldRecalculate, setShouldRecalculate] = useState(false) // CRITICAL: Flag to control when useEffect should run
    const [isViewFlag, setIsViewFlag] = useState(false)
    const [isLoader, setIsLoader] = useState(false)
    const [scrapRateviewTooltip, setScrapRateViewTooltip] = useState(false)
    const [currentBopId, setCurrentBopId] = useState('') // CRITICAL: Store BoughtOutPartId for correct row identification  

    const { register, control, setValue, formState: { errors }, } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
    })

    const dispatch = useDispatch()
    const currencySelectList = useSelector(state => state.comman.currencySelectList)
    const masterList = useSelector(state => state.simulation.masterSelectListSimulation)
    const { selectedMasterForSimulation, selectedTechnologyForSimulation, exchangeRateListBeforeDraft } = useSelector(state => state.simulation)

    // ENHANCEMENT: Performance - Memoize configuration values to prevent unnecessary recalculations
    const configKeys = useMemo(() => getConfigurationKey(), []);
    const isMinOrderQtyVisible = useMemo(() => configKeys.IsMinimumOrderQuantityVisible, [configKeys]);
    const decimalPlaces = useMemo(() => configKeys.NoOfDecimalForPrice, [configKeys]);
    const isBasicRateVisible = useMemo(() => configKeys.IsBasicRateAndCostingConditionVisible, [configKeys]);

    // ========================================================================
    // COMMON HOOKS - Using centralized simulation hooks
    // ========================================================================

    // Grid operations and pagination preservation
    const {
        gridApi,
        setGridApi,
        currentPage,
        currentPageSize,
        setCurrentPage,
        setCurrentPageSize,
        findNodeByRowId,
        refreshGridRow,
        refreshMultipleRows,
        onGridReady: commonOnGridReady,
        onPageSizeChanged: commonOnPageSizeChanged
    } = useSimulationGrid({
        defaultPageSize
    });

    // Undo functionality with keyboard shortcuts (from common hooks)
    const {
        saveUndoState,
        handleUndo,
        handleRedo,
        undoCount,
        redoCount,
        canUndo,
        canRedo
    } = useSimulationUndo({
        gridApi,
        findNodeByRowId,
        disabled: false,
        enableKeyboardShortcuts: true,
        updateListData: useCallback((rowId, restoredData) => {
            // CRITICAL FIX: Use ID instead of index to handle filtering correctly
            const actualIndex = list.findIndex(item =>
                (item.BoughtOutPartId || item.CostingId) === rowId
            );
            if (actualIndex !== -1) {
                list[actualIndex] = restoredData;
                // Update grid node by ID
                const node = findNodeByRowId(rowId);
                if (node) {
                    node.setData(restoredData);
                }
            }
        }, [list, findNodeByRowId])
    });

    // VBC support - Costing type detection (from common hooks)
    const {
        hasZBCRows,
        hasVBCRows,
        shouldShowConditionCostColumn,
        isVBCRow
    } = useSimulationVBC({
        list,
        ZBCTypeId,
        VBCTypeId,
        CBCTypeId
    });

    const columnWidths = {
        // Base column widths - used for compressed/expanded views
        COMPRESSED_WIDTH: 50,
        STANDARD_WIDTH: {
            SMALL: 80,
            MEDIUM: 120,
            LARGE: 160,
            EXTRA_LARGE: 190
        },

        // Main Information Columns
        BoughtOutPartNumber: showCompressedColumns ? 50 : 140,
        BoughtOutPartName: showCompressedColumns ? 100 : 140,
        BoughtOutPartCategory: showCompressedColumns ? 100 : 140,
        Vendor: showCompressedColumns ? 100 : 140,
        CustomerName: showCompressedColumns ? 100 : 140,
        Plants: showCompressedColumns ? 100 : 140,
        NumberOfPieces: showCompressedColumns ? 100 : 140,
        Percentage: showCompressedColumns ? 60 : 100,
        EffectiveDate: showCompressedColumns ? 90 : 140,
        CostingId: showCompressedColumns ? 90 : 140,

        // Cost Columns with Existing/Revised structure
        BasicRate: {
            existing: showCompressedColumns ? 60 : 120,
            revised: showCompressedColumns ? 60 : 120,
            group: showCompressedColumns ? 120 : 240
        },
        OtherCost: {
            existing: showCompressedColumns ? 60 : 100,
            revised: showCompressedColumns ? 60 : 120,
            group: showCompressedColumns ? 120 : 200
        },
        BasicPrice: {
            existing: showCompressedColumns ? 60 : 100,
            revised: showCompressedColumns ? 60 : 100,
            group: showCompressedColumns ? 120 : 200
        },
        ConditionCost: {
            existing: showCompressedColumns ? 60 : 100,
            revised: showCompressedColumns ? 60 : 100,
            group: showCompressedColumns ? 120 : 200
        },
        NetCost: {
            existing: showCompressedColumns ? 60 : 100,
            revised: showCompressedColumns ? 60 : 100,
            group: showCompressedColumns ? 120 : 200
        },
        PlantCurrency: {
            existing: showCompressedColumns ? 60 : 120,
            revised: showCompressedColumns ? 60 : 120,
            group: showCompressedColumns ? 120 : 240
        },

        // Legacy support for existing columnWidths usage
        NewNetCostWithoutConditionCost: showCompressedColumns ? 70 : 120,
        NetCostWithoutConditionCost: showCompressedColumns ? 70 : 120,
        NewOtherNetCost: showCompressedColumns ? 70 : 120,
        OtherNetCost: showCompressedColumns ? 70 : 120
    };
    // Separate useEffect to handle bulk upload count updates when isbulkUpload changes
    useEffect(() => {
        if (isbulkUpload && rowCount) {
            setValue('NoOfCorrectRow', rowCount.correctRow)
            setValue('NoOfRowsWithoutChange', rowCount.NoOfRowsWithoutChange)
            setTitleObj(prevState => ({ ...prevState, rowWithChanges: rowCount.correctRow, rowWithoutChanges: rowCount.NoOfRowsWithoutChange }))
        }
    }, [isbulkUpload, rowCount])

    useEffect(() => {
        list && list?.map(item => {
            // Only set default values if they don't already exist (to preserve bulk upload data)
            if (item.NewBasicRate === undefined || item.NewBasicRate === null) {
                item.NewBasicRate = item.BasicRate
            }
            item.OldNetLandedCost = item.NetLandedCost
            item.NewNetLandedCost = item.NetLandedCost
        })

        if (!isbulkUpload) {
            list && list?.map(item => {
                // Only set default values if they don't already exist (to preserve bulk upload data)
                if (item.NewBasicRate === undefined || item.NewBasicRate === null) {
                    item.NewBasicRate = item.BasicRate
                }
                if (item.NewScrapRatePerScrapUOM === undefined || item.NewScrapRatePerScrapUOM === null) {
                    item.NewScrapRatePerScrapUOM = item.ScrapRatePerScrapUOM
                }
                if (item.NewOtherNetCost === undefined || item.NewOtherNetCost === null) {
                    item.NewOtherNetCost = item.OtherNetCost
                }
                if (item.NewNetConditionCost === undefined || item.NewNetConditionCost === null) {
                    item.NewNetConditionCost = item.NetConditionCost  // ADD KEY FROM API
                }
                if (item.NewNetCostWithoutConditionCost === undefined || item.NewNetCostWithoutConditionCost === null) {
                    item.NewNetCostWithoutConditionCost = item.NetCostWithoutConditionCost
                }
                if (!item.NewBoughtOutPartOtherCostDetailsSchema) {
                    item.NewBoughtOutPartOtherCostDetailsSchema = item.BoughtOutPartOtherCostDetailsSchema || []; // Set to existing data or empty array
                }
                if (!item.NewBoughtOutPartConditionsDetails) {
                    item.NewBoughtOutPartConditionsDetails = item.BoughtOutPartConditionsDetails || []; // Set to existing data or empty array
                }
                setNetCostWithoutConditionCost(item.NewNetCostWithoutConditionCost)
            })
        }
    }, [])
    useEffect(() => {

        if (handleEditMasterPage) {
            handleEditMasterPage(showEditMaster, showverifyPage)
        }
    }, [showverifyPage])
    useEffect(() => {
        if (list && list.length > 0) {
            window.screen.width >= 1920 && gridRef?.current?.api?.sizeColumnsToFit();
            let maxDate = getMaxDate(list)
            setMaxDate(parsedDate(maxDate?.EffectiveDate));
        }
    }, [list])
    useEffect(() => {
        // CRITICAL FIX: Use editRowId instead of rowIndex to find the correct row
        // CRITICAL: Only recalculate when shouldRecalculate is true (i.e., when Basic Rate is edited in grid)
        if (list && editRowId && basicRate !== '' && shouldRecalculate) {

            // Find actual index by ID, not by visual position
            const actualIndex = list.findIndex(item =>
                (item.BoughtOutPartId || item.CostingId) === editRowId
            );
            if (actualIndex === -1 || !list[actualIndex]) {
                console.error('Row not found with ID:', editRowId);
                setShouldRecalculate(false);
                return;
            }

            let obj = list[actualIndex];  // Use actual index, not visual rowIndex
            obj.otherCostTableData = obj.NewBoughtOutPartOtherCostDetailsSchema;
            obj.conditionTableData = obj.NewBoughtOutPartConditionsDetails;

            // CRITICAL FIX: Update ApplicabilityCost in the table data for percentage-based costs
            // When Applicability is "Basic Rate" and Type is "Percentage", we need to update
            // the ApplicabilityCost to the NEW basic rate before recalculating
            if (obj.otherCostTableData && Array.isArray(obj.otherCostTableData)) {
                obj.otherCostTableData.forEach(item => {
                    if (item.Type === 'Percentage' && item.Applicability === 'Basic Rate') {
                        item.ApplicabilityCost = basicRate;
                        item.ApplicabilityCostConversion = basicRate;
                        // Recalculate NetCost based on new basic rate
                        const percentageValue = parseFloat(item.Value) || 0;
                        item.NetCost = preciseDivide(preciseMultiply(basicRate, percentageValue), 100);
                        item.NetCostConversion = item.NetCost;
                    }
                });
            }

            // CRITICAL: Save the updated table data back to the schema
            obj.NewBoughtOutPartOtherCostDetailsSchema = obj.otherCostTableData;

            const updatedObjOtherCost = updateCostValue(false, obj, basicRate, true);

            // Update with the recalculated values
            obj.NewBoughtOutPartOtherCostDetailsSchema = updatedObjOtherCost?.tableData;

            obj.NewOtherNetCost = updatedObjOtherCost?.formValue?.value;
            obj.NewOtherNetCostConversion = updatedObjOtherCost?.formValue?.value;
            obj.NewOtherNetCostLocalConversion = updatedObjOtherCost?.formValue?.value;

            const basicPrice = preciseAdd(checkForNull(basicRate), checkForNull(updatedObjOtherCost?.formValue?.value));

            const updatedObjConditionCost = updateCostValue(true, obj, basicPrice, true);
            obj.NewBoughtOutPartConditionsDetails = updatedObjConditionCost?.tableData;

            obj.NewNetConditionCost = updatedObjConditionCost?.formValue?.value;
            obj.NewConditionNetCostConversion = updatedObjConditionCost?.formValue?.value;
            obj.NewConditionNetCostLocalConversion = updatedObjConditionCost?.formValue?.value;

            obj.NewNetLandedCost = preciseAdd(checkForNull(basicRate), checkForNull(updatedObjOtherCost?.formValue?.value), checkForNull(updatedObjConditionCost?.formValue?.value));
            obj.NewNetCostWithoutConditionCost = preciseAdd(checkForNull(basicRate), checkForNull(updatedObjOtherCost?.formValue?.value));
            obj.NewNetLandedCostConversion = preciseAdd(checkForNull(basicRate), checkForNull(updatedObjOtherCost?.formValue?.value), checkForNull(updatedObjConditionCost?.formValue?.value));
            obj.NewNetLandedCostLocalConversion = preciseAdd(checkForNull(basicRate), checkForNull(updatedObjOtherCost?.formValue?.value), checkForNull(updatedObjConditionCost?.formValue?.value));

            setNetCostWithoutConditionCost(obj.NewNetCostWithoutConditionCost);

            list[actualIndex] = obj;  // Use actual index, not visual rowIndex

            // Update grid node by ID
            const rowId = list[actualIndex]?.BoughtOutPartId || list[actualIndex]?.CostingId;
            const node = findNodeByRowId(rowId);
            if (node) {
                node.setData(list[actualIndex]);
            }

            // Reset flag after recalculation
            setShouldRecalculate(false);
        }
    }, [basicRate, editRowId, shouldRecalculate])
    const verifySimulation = debounce(() => {
        if (selectedMasterForSimulation?.value === EXCHNAGERATE) {
            dispatch(createMultipleExchangeRate(exchangeRateListBeforeDraft, currencySelectList, effectiveDate, res => {
                if (!res?.status && !res?.error) {
                    setValueFunction(true, res);
                }
            }))
        } else {
            setValueFunction(false, []);
        }
        setShowTooltip(false)
    }, 500)
    const setValueFunction = (isExchangeRate, res) => {
        const filteredMasterId = masterList?.find(item => item?.Text === "BOP Import")?.Value;

        if (!isEffectiveDateSelected) {
            setIsWarningMessageShow(true)
            return false
        }

        let obj = {
            SimulationTechnologyId: isExchangeRate ? EXCHNAGERATE : selectedMasterForSimulation?.value,
            SimulationTypeId: list[0].CostingTypeId,
            LoggedInUserId: loggedInUserId(),
            TechnologyId: selectedTechnologyForSimulation?.value ? selectedTechnologyForSimulation?.value : null,
            TechnologyName: selectedTechnologyForSimulation?.label ? selectedTechnologyForSimulation?.label : null,
            EffectiveDate: DayTime(effectiveDate).format('YYYY-MM-DD HH:mm:ss'),
            SimulationHeadId: list[0].CostingTypeId,
            IsSimulationWithOutCosting: true,
            SimulationIds: tokenForMultiSimulation,
            IsExchangeRateSimulation: false,
            ExchangeRateSimulationTechnologyId: filteredMasterId

        }

        let tempArr = []
        list && list.map(item => {
            let tempObj = {
                BoughtOutPartId: item.BoughtOutPartId,
                OldBOPRate: item.BasicRate,
                NewBOPRate: 0,
                OldNetLandedCost: 0,
                NewNetLandedCost: 0,
                PercentageChange: 0,
                NewOtherNetCost: item.NewOtherNetCost || 0,
                NewNetConditionCost: item.NewNetConditionCost || 0,
                NewNetCostWithoutConditionCost: item.NewNetCostWithoutConditionCost || 0,
                BoughtOutPartConditionsDetails: item.NewBoughtOutPartConditionsDetails || [],
                BoughtOutPartOtherCostDetailsSchema: item.NewBoughtOutPartOtherCostDetailsSchema || []
            }

            if ((item?.Percentage !== '') && (checkForNull(item?.Percentage) !== 0)) {
                const val = preciseAdd(item?.BasicRate, preciseDivide(preciseMultiply(item?.BasicRate, item?.Percentage), 100))
                tempObj.NewBOPRate = val
                tempObj.OldNetLandedCost = preciseAdd(preciseDivide(preciseAdd(checkForNull(item.BasicRate), checkForNull(item?.OtherNetCost)), (getConfigurationKey().IsMinimumOrderQuantityVisible ? checkForNull(item?.NumberOfPieces) : 1)), checkForNull(item?.NetConditionCost))
                tempObj.NewNetLandedCost = preciseAdd(preciseDivide(preciseAdd(checkForNull(val), checkForNull(item.NewOtherNetCost)), (getConfigurationKey().IsMinimumOrderQuantityVisible ? checkForNull(item?.NumberOfPieces) : 1)), checkForNull(item.NewNetConditionCost))
                tempObj.PercentageChange = checkForNull(item.Percentage)
            } else {
                tempObj.NewBOPRate = item.NewBasicRate
                tempObj.OldNetLandedCost = preciseAdd(preciseDivide(preciseAdd(checkForNull(item.BasicRate), checkForNull(item?.OtherNetCost)), (getConfigurationKey().IsMinimumOrderQuantityVisible ? checkForNull(item?.NumberOfPieces) : 1)), checkForNull(item?.NetConditionCost))
                tempObj.NewNetLandedCost = preciseAdd(preciseDivide(preciseAdd(Number(item.NewBasicRate ? item.NewBasicRate : item.BasicRate), checkForNull(item.NewOtherNetCost)), (getConfigurationKey().IsMinimumOrderQuantityVisible ? checkForNull(item?.NumberOfPieces) : 1)), checkForNull(item.NewNetConditionCost))
            }
            if (checkForNull(tempObj.OldNetLandedCost) !== checkForNull(tempObj.NewNetLandedCost)) {
                tempArr.push(tempObj)
            }
            return null;
        })


        let check = 0
        let percentageCheck = 0
        tempArr && tempArr?.map(item => {
            if (checkForNull(item?.OldNetLandedCost) !== checkForNull(item?.NewNetLandedCost)) {
                check = check + 1
            }
            if (item?.PercentageChange > 100) {
                percentageCheck = percentageCheck + 1
            }
        })
        if (check === 0) {
            Toaster.warning("There is no changes in net cost. Please change, then run simulation")
            return false
        } else if (percentageCheck !== 0) {
            Toaster.warning("Percentage should be less than or equal to 100")
            return false
        }
        setIsDisable(true)
        obj.SimulationBoughtOutPart = tempArr

        dispatch(runVerifyBoughtOutPartSimulation(obj, res => {
            setIsDisable(false)
            if (res?.data?.Result) {
                setToken(res.data.Identity)
                setShowVerifyPage(true)
            }
        }))
    }
    const cancelVerifyPage = () => {
        setShowVerifyPage(false)
    }

    const effectiveDateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;

        return cell != null ? <span title={DayTime(cell).format('DD/MM/YYYY')}> {cell.includes("T") ? DayTime(cell).format('DD/MM/YYYY') : cell}</span> : '';
    }

    const costingHeadFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return cell ? cell : '-';
    }

    const customerFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (isbulkUpload ? row['Customer (Code)'] : row.CustomerName);
    }

    const percentageFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        let cellValue = cell
        if (cell && cell > 100) {
            Toaster.warning("Percentage should be less than or equal to 100")
            list[props.rowIndex].Percentage = 0
            cellValue = 0
        }
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;


        const value = beforeSaveCell(cellValue, props, 'percentage')
        return (
            <>
                {
                    <span className={`form-control ${Number(row.OldNetLandedCost) !== Number(row.NewBasicRate) ? 'disabled' : ''}`} >{cell && value ? Number(cellValue) : (row?.Percentage ? row?.Percentage : 0)} </span>
                }

            </>
        )
    }

    const oldBasicRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (
            <>
                {<span title={cell && Number(row.BasicRate)}>{cell && Number(row.BasicRate)} </span>}

            </>
        )
    }
    const newBasicRateFormatter = (props) => {
        const row = props?.data;

        // REMOVED: beforeSaveCell validation call - formatters should only display, not validate

        // Calculate the display value based on percentage or direct entry
        let newValue = 0;
        let oldValue = Number(row.BasicRate);
        let isPercentageApplied = (row?.Percentage !== '') && (checkForNull(row?.Percentage) !== 0) && checkForNull(row?.Percentage) <= 100;

        if (isPercentageApplied) {
            // When percentage is applied, calculate the new basic rate
            newValue = preciseAdd(row.BasicRate, preciseDivide(preciseMultiply(row.BasicRate, row.Percentage), 100));
        } else {
            // When direct entry is used
            newValue = Number(row.NewBasicRate || row.BasicRate);
        }

        const decimalPlaces = isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6;
        const displayValue = checkForDecimalAndNull(newValue, decimalPlaces);

        return (
            <div id={`newBasicRate-${props.rowIndex}`} className='ag-header-cell-label'>
                <PriceComparisonSpan
                    newValue={newValue}
                    oldValue={oldValue}
                    costingTypeId={row?.CostingTypeId}
                    className={`form-control mt-1 ${isPercentageApplied ? 'disabled' : ''}`}
                    title={displayValue}
                >
                    {displayValue}
                </PriceComparisonSpan>
            </div>
        )
    }

    const vendorFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (
            <>
                {isbulkUpload ? row[`Vendor (Code)`] : cell}

            </>
        )
    }

    const plantFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (
            <>
                {isbulkUpload ? row['Plant (Code)'] : cell}

            </>
        )
    }

    const costFormatter = (props) => {

        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        if (!row.NewBasicRate || row.BasicRate === row.NewBasicRate || row.NewBasicRate === '') return checkForDecimalAndNull(cell, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)
        const tempA = Number(row.NewBasicRate) + checkForNull(row.RMFreightCost) + checkForNull(row.RMShearingCost);
        const classGreen = (tempA > row.NetLandedCost) ? 'red-value form-control' : (tempA < row.NetLandedCost) ? 'green-value form-control' : 'form-class'
        return cell != null ? <span className={classGreen}>{checkForDecimalAndNull(cell, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}</span> : ''
    }

    /**
    * @method beforeSaveCell
    * @description CHECK FOR ENTER NUMBER IN CELL using common validation
    */
    const beforeSaveCell = (cellValue, props, type) => {
        return validateRevisedRate(cellValue, props, type || 'basicRate', { isBOP: true });
    }

    const NewcostFormatter = (props) => {
        const row = props?.data;
        const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? Number(row?.NumberOfPieces) : 1;

        // FIXED: Calculate old and new net landed costs correctly
        // Old Net Landed Cost = (Old Basic Rate + Old Other Cost) / NumberOfPieces + Old Condition Cost
        const existingBasicPrice = preciseDivide(preciseAdd(Number(row.BasicRate), checkForNull(row?.OtherNetCost)), NumberOfPieces);
        const existingNetLandedCost = preciseAdd(existingBasicPrice, checkForNull(row?.NetConditionCost));

        // New Net Landed Cost calculation based on percentage or direct entry
        let newBasicRate = Number(row.NewBasicRate || row.BasicRate);

        // If percentage is applied, calculate new basic rate
        if ((row?.Percentage !== '') && (checkForNull(row?.Percentage) !== 0) && checkForNull(row?.Percentage) <= 100) {
            newBasicRate = preciseAdd(row.BasicRate, preciseDivide(preciseMultiply(row.BasicRate, row.Percentage), 100));
        }

        const newBasicPrice = preciseDivide(preciseAdd(checkForNull(newBasicRate), checkForNull(row?.NewOtherNetCost)), NumberOfPieces);
        const newNetLandedCost = preciseAdd(newBasicPrice, checkForNull(row?.NewNetConditionCost));

        // Display the appropriate value
        const displayCost = row.NewBasicRate != null || row.Percentage != null ? newNetLandedCost : existingNetLandedCost;
        const decimalPlaces = isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6;

        return (
            <div id="netCost_revised" className='ag-header-cell-label'>
                <PriceComparisonSpan
                    newValue={newNetLandedCost}
                    oldValue={existingNetLandedCost}
                    costingTypeId={row?.CostingTypeId}
                    className={row.NewBasicRate != null || row.Percentage != null ? "form-control" : ''}
                    title={checkForDecimalAndNull(displayCost, decimalPlaces)}
                >
                    {checkForDecimalAndNull(displayCost, decimalPlaces)}
                </PriceComparisonSpan>
            </div>
        );
    };
    const OldcostFormatter = (props) => {
        const row = props?.data;
        const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? Number(row?.NumberOfPieces) : 1
        const NetLandedCost = preciseAdd(preciseDivide(preciseAdd(checkForNull(row.BasicRate), checkForNull(row?.OtherNetCost)), NumberOfPieces), checkForNull(row?.NetConditionCost))
        if (!row.BasicRate || row.BasicRate === '') return ''
        //return row.BasicRate != null ? <span title={checkForDecimalAndNull(Number(row.BasicRate) / NumberOfPieces, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}>{checkForDecimalAndNull(Number(row.BasicRate) / NumberOfPieces, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}</span> : ''
        return checkForDecimalAndNull(NetLandedCost, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)
    }

    const revisedBasicRateHeader = (props) => {
        return (
            <div className='ag-header-cell-label'>
                <span className='ag-header-cell-text basicRate_revised'>Revised{<i className={`fa fa-info-circle tooltip_custom_right tooltip-icon mb-n3 ml-4 mt2 `} id={"basicRate-tooltip"}></i>}</span>
            </div>
        );
    };

    const revisedScrapRateHeader = (props) => {
        return (
            <div className='ag-header-cell-label'>
                <span className='ag-header-cell-text'>Revised {!props?.isImpactedMaster && <i className={`fa fa-info-circle tooltip_custom_right tooltip-icon mb-n3 ml-4 mt2 `} id={"scrapRate-tooltip"}></i>} </span>
            </div>
        );
    };
    const cancel = () => {
        list && list.map((item) => {
            item.NewBasicRate = undefined
            return null
        })
        props.backToSimulation(true)
    }

    const closeDrawer = (e = '') => {
        setShowRunSimulationDrawer(false)
    }

    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
        editable: true,
        floatingFilter: true,
        suppressSizeToFit: true
    };

    const getRowNodeId = (data) => {
        return data.BoughtOutPartId;
    };

    const onGridReady = (params) => {
        // Use common hook's onGridReady for pagination restoration
        commonOnGridReady(params);

        // Component-specific initialization
        setGridColumnApi(params.columnApi)
        window.screen.width >= 1440 && params.api.sizeColumnsToFit();
        setTimeout(() => {
            setShowTooltip(true)
        }, 100);
    };
    const onFloatingFilterChanged = (value) => {
        setTimeout(() => {
            if (list.length !== 0) {
                setNoData(searchNocontentFilter(value, noData))
            }
        }, 500);
    }
    const onPageSizeChanged = (newPageSize) => {
        gridApi.paginationSetPageSize(Number(newPageSize));
        // Use common hook's page size tracking
        commonOnPageSizeChanged(newPageSize);
    };

    const onFilterTextBoxChanged = (e) => {
        gridApi.setQuickFilter(e.target.value);
    }

    const cellChange = (props) => {
        const rowData = props?.data;

        if (rowData && props.colDef && props.colDef.colId === 'NewBasicRate') {
            // Validate basic rate before processing
            const validation = validateAndFormatValue(rowData.NewBasicRate, props, 'basicRate');
            if (!validation.isValid) {
                // Reset to last valid value in both grid and state
                resetFieldToLastValidValue(rowData, 'basicRate', props, gridApi, list, props.node.rowIndex);
                return;
            }
        }

        if (rowData && props.colDef && props.colDef.colId === 'Percentage') {
            // Validate percentage before processing
            const validation = validateAndFormatValue(rowData.Percentage, props, 'percentage');
            if (!validation.isValid) {
                // Reset to last valid value in both grid and state
                resetFieldToLastValidValue(rowData, 'percentage', props, gridApi, list, props.node.rowIndex);
                return;
            }
        }
    }
    const resetState = () => {
        // Clear the search input field in DOM
        const searchBox = document.getElementById("filter-text-box");
        if (searchBox) {
            searchBox.value = "";
        }

        // Clear grid quick filter
        gridApi?.setQuickFilter('');

        // Reset grid column state and filter models using gridRef
        if (gridRef.current?.columnApi) {
            gridRef.current.columnApi.resetColumnState();
        }
        if (gridRef.current?.api) {
            gridRef.current.api.setFilterModel(null);
        }

        // Resize columns to fit if needed
        if (window.screen.width >= 1440 && gridRef.current?.api) {
            gridRef.current.api.sizeColumnsToFit();
        }
    }
    const handleEffectiveDateChange = (date) => {
        setEffectiveDate(date)
        setIsEffectiveDateSelected(true)
        setIsWarningMessageShow(false)
    }
    const onCellValueChanged = (props) => {
        const rowData = props?.data

        if (rowData) {
            // ENHANCEMENT: Store current page and page size before any updates
            if (gridApi) {
                setCurrentPage(gridApi.paginationGetCurrentPage());
                setCurrentPageSize(gridApi.paginationGetPageSize());
            }

            // CRITICAL FIX: Create deep copy of OLD data BEFORE any changes
            // props.data already has NEW value, so we reconstruct the OLD state
            const rowIndex = props.node.rowIndex;
            const oldRowData = JSON.parse(JSON.stringify(rowData));

            // Restore the OLD value for the changed field
            if (props.colDef?.colId && props.oldValue !== undefined) {
                oldRowData[props.colDef.field || props.colDef.colId] = props.oldValue;
            }

            // Validate the changed value based on the column
            let validation = null;
            if (props.colDef?.colId === 'NewBasicRate') {
                validation = validateAndFormatValue(rowData.NewBasicRate, props, 'basicRate');
                if (!validation.isValid) {
                    // Reset to last valid value in both grid and state
                    resetFieldToLastValidValue(rowData, 'basicRate', props, gridApi, list, props.node.rowIndex);
                    return;
                }

                // CRITICAL VALIDATION: Basic Rate cannot be negative
                const basicRateValue = Number(rowData.NewBasicRate);
                if (basicRateValue < 0) {
                    Toaster.error('Basic Rate cannot be negative. Please enter a valid positive value.');
                    resetFieldToLastValidValue(rowData, 'basicRate', props, gridApi, list, props.node.rowIndex);
                    return;
                }

                // ENHANCEMENT: Save undo state with OLD data (before changes)
                saveUndoState(oldRowData, `Edit Basic Rate`);

                // ENHANCEMENT: Recalculate dependent fields when basic rate changes
                const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? Number(rowData?.NumberOfPieces) : 1;

                // Calculate based on percentage or direct entry
                let finalBasicRate = basicRateValue;
                if ((rowData?.Percentage !== '') && (checkForNull(rowData?.Percentage) !== 0) && checkForNull(rowData?.Percentage) <= 100) {
                    finalBasicRate = preciseAdd(rowData.BasicRate, preciseDivide(preciseMultiply(rowData.BasicRate, rowData.Percentage), 100));
                    rowData.NewBasicRate = finalBasicRate;
                }

                // Recalculate NewNetCostWithoutConditionCost (Basic Price)
                rowData.NewNetCostWithoutConditionCost = preciseDivide(preciseAdd(checkForNull(finalBasicRate), checkForNull(rowData?.NewOtherNetCost)), NumberOfPieces);

                // Recalculate NewNetLandedCost (Net Cost)
                rowData.NewNetLandedCost = preciseAdd(preciseDivide(preciseAdd(checkForNull(finalBasicRate), checkForNull(rowData?.NewOtherNetCost)), NumberOfPieces), checkForNull(rowData?.NewNetConditionCost));

                // Update conversion fields
                rowData.NewNetLandedCostConversion = rowData.NewNetLandedCost;
                rowData.NewNetLandedCostLocalConversion = rowData.NewNetLandedCost;

                // ENHANCEMENT: Refresh affected cells immediately WITHOUT LOADER
                if (gridApi && props.node) {
                    gridApi.refreshCells({
                        rowNodes: [props.node],
                        columns: ['NewNetCostWithoutConditionCost', 'NewNetLandedCost'],
                        force: true
                    });
                }

                // Update state
                setBasicRate(finalBasicRate);
                setNetCostWithoutConditionCost(rowData.NewNetCostWithoutConditionCost);

                // CRITICAL: Set editRowId so useEffect knows which row to update
                const rowId = rowData?.BoughtOutPartId || rowData?.CostingId;
                setEditRowId(rowId);
                setShouldRecalculate(true); // CRITICAL: Enable recalculation in useEffect

            } else if (props.colDef?.colId === 'Percentage') {
                validation = validateAndFormatValue(rowData.Percentage, props, 'percentage');
                if (!validation.isValid) {
                    // Reset to last valid value in both grid and state
                    resetFieldToLastValidValue(rowData, 'percentage', props, gridApi, list, props.node.rowIndex);
                    return;
                }

                // ENHANCEMENT: Save undo state before changes
                saveUndoState(oldRowData, `Edit Percentage`);

                // ENHANCEMENT: Recalculate when percentage changes
                const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? Number(rowData?.NumberOfPieces) : 1;
                const percentageValue = checkForNull(rowData.Percentage);

                if (percentageValue > 0 && percentageValue <= 100) {
                    // Calculate new basic rate based on percentage
                    const newBasicRate = preciseAdd(rowData.BasicRate, preciseDivide(preciseMultiply(rowData.BasicRate, percentageValue), 100));
                    rowData.NewBasicRate = newBasicRate;

                    // Recalculate dependent fields
                    rowData.NewNetCostWithoutConditionCost = preciseDivide(preciseAdd(checkForNull(newBasicRate), checkForNull(rowData?.NewOtherNetCost)), NumberOfPieces);
                    rowData.NewNetLandedCost = preciseAdd(preciseDivide(preciseAdd(checkForNull(newBasicRate), checkForNull(rowData?.NewOtherNetCost)), NumberOfPieces), checkForNull(rowData?.NewNetConditionCost));
                    rowData.NewNetLandedCostConversion = rowData.NewNetLandedCost;
                    rowData.NewNetLandedCostLocalConversion = rowData.NewNetLandedCost;

                    // ENHANCEMENT: Refresh affected cells immediately WITHOUT LOADER
                    if (gridApi && props.node) {
                        gridApi.refreshCells({
                            rowNodes: [props.node],
                            columns: ['NewBasicRate', 'NewNetCostWithoutConditionCost', 'NewNetLandedCost'],
                            force: true
                        });
                    }

                    setBasicRate(newBasicRate);
                    setNetCostWithoutConditionCost(rowData.NewNetCostWithoutConditionCost);

                    // CRITICAL: Set editRowId so useEffect knows which row to update
                    const rowId = rowData?.BoughtOutPartId || rowData?.CostingId;
                    setEditRowId(rowId);
                    setShouldRecalculate(true); // CRITICAL: Enable recalculation in useEffect
                }
            }
        }
    }

    const EditableCallbackForBasicRate = (props) => {
        const rowData = props?.data;
        let value = false
        if ((rowData?.Percentage !== '') && (checkForNull(rowData?.Percentage) !== 0)) {
            value = false
        } else {
            value = true
        }
        setRowIndex(props?.node?.rowIndex)
        setCurrentBopId(rowData?.BoughtOutPartId) // Store BoughtOutPartId for correct row identification
        return value
    }

    const EditableCallbackForPercentage = (props) => {
        const rowData = props?.data;
        let value = false
        if (Number(rowData?.BasicRate) === Number(rowData?.NewBasicRate)) {
            value = true
        } else {
            value = false
        }
        return value
    }

    const ageValueGetter = (params) => {
        let row = params.data
        let valueReturn = ''
        if ((row?.Percentage !== '') && (checkForNull(row?.Percentage) !== 0) && checkForNull(row?.Percentage) <= 100) {
            valueReturn = preciseAdd(row?.BasicRate, preciseDivide(preciseMultiply(row?.BasicRate, row?.Percentage), 100))
        } else {
            valueReturn = row?.NewBasicRate
        }
        return valueReturn;
    };
    const ageValueGetterPer = (params) => {
        let row = params.data
        if (!row.Percentage) {
            if (Number(row.NewBasicRate) === Number(row.OldNetLandedCost)) {
                return ""
            }
            return row?.NewBasicRate * 0;
        }
        else if (Number(row.Percentage) === 0) {
            if (Number(row.NewBasicRate) === Number(row.OldNetLandedCost)) {
                return ""
            }
        } else {
            return row?.Percentage
        }
    };

    const ageValueGetterLanded = (params) => {
        let row = params.data
        const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? Number(row?.NumberOfPieces) : 1
        let valueReturn = ''
        if ((row?.Percentage !== '') && (checkForNull(row?.Percentage) !== 0) && checkForNull(row?.Percentage) <= 100) {
            valueReturn = preciseDivide(preciseAdd(row?.BasicRate, preciseDivide(preciseMultiply(row?.BasicRate, row?.Percentage), 100)), NumberOfPieces)
        } else {
            valueReturn = preciseDivide(row?.NewBasicRate, NumberOfPieces)
        }
        return valueReturn;
    };
    const otherCostDrawer = (value, row, index, type) => {
        // CRITICAL FIX: Store unique ID instead of index to handle filtering correctly
        const rowId = row?.BoughtOutPartId || row?.CostingId;

        setRowData(row)
        setBasicRate(row?.NewBasicRate)
        setEditRowId(rowId) // Store ID, not index
        setShouldRecalculate(false) // CRITICAL: Don't recalculate when just opening drawer

        if (type === 'Old') {
            setOtherCostDetailForRow(row?.BoughtOutPartOtherCostDetailsSchema || [])
            setIsViewFlag(true)
        } else {
            setOtherCostDetailForRow(props?.isImpactedMaster ? row?.SimulationBoughtOutPartOtherCostDetailsList || [] : row?.NewBoughtOutPartOtherCostDetailsSchema || []);
            setIsViewFlag(false)
        }
        setOpenOtherCostDrawer(true)
    }
    const calculateAndSave = (tableData, totalCostBase) => {
        // CRITICAL FIX: Find row by ID instead of using index (handles filtering correctly)
        // Find the actual index in the list array by ID
        const actualIndex = list.findIndex(item =>
            (item.BoughtOutPartId || item.CostingId) === editRowId
        );

        if (actualIndex === -1) {
            console.error('Row not found with ID:', editRowId);
            Toaster.error('Unable to update Other Cost. Row not found.');
            return;
        }

        const oldData = JSON.parse(JSON.stringify(list[actualIndex]));

        // ENHANCEMENT: Store current page and page size before updates
        const savedPage = gridApi ? gridApi.paginationGetCurrentPage() : currentPage;
        const savedPageSize = gridApi ? gridApi.paginationGetPageSize() : currentPageSize;

        // ENHANCEMENT: Save undo state before changes
        saveUndoState(oldData, `Update Other Cost`);

        // Calculate with NumberOfPieces
        const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? Number(list[actualIndex]?.NumberOfPieces) : 1;

        list[actualIndex].NewOtherNetCost = totalCostBase;
        list[actualIndex].NewOtherNetCostConversion = totalCostBase;
        list[actualIndex].NewOtherNetCostLocalConversion = totalCostBase;
        list[actualIndex].NewBoughtOutPartOtherCostDetailsSchema = tableData;

        // Recalculate NewNetCostWithoutConditionCost (Basic Price) = (Basic Rate + Other Cost) / NumberOfPieces
        list[actualIndex].NewNetCostWithoutConditionCost = preciseDivide(preciseAdd(checkForNull(list[actualIndex].NewBasicRate), checkForNull(totalCostBase)), NumberOfPieces);

        // Recalculate NewNetLandedCost (Net Cost) = Basic Price + Condition Cost
        list[actualIndex].NewNetLandedCost = preciseAdd(list[actualIndex].NewNetCostWithoutConditionCost, checkForNull(list[actualIndex].NewNetConditionCost));

        // Update conversion fields
        list[actualIndex].NewNetLandedCostConversion = list[actualIndex].NewNetLandedCost;
        list[actualIndex].NewNetLandedCostLocalConversion = list[actualIndex].NewNetLandedCost;

        setNetCostWithoutConditionCost(list[actualIndex].NewNetCostWithoutConditionCost);

        // CRITICAL FIX: Update the grid node directly using ID, not index
        const rowId = list[actualIndex]?.BoughtOutPartId || list[actualIndex]?.CostingId;

        const node = findNodeByRowId(rowId);
        if (node) {
            node.setData(list[actualIndex]);
        } else {
            console.error('Grid node not found for ID:', rowId);
        }

        // Restore pagination
        if (gridApi && savedPage !== undefined) {
            setTimeout(() => {
                gridApi.paginationGoToPage(savedPage);
            }, 0);
        }
    }

    const calculateAndSaveCondition = (tableData, totalCostBase) => {
        // CRITICAL FIX: Find row by ID instead of using index (handles filtering correctly)
        // Find the actual index in the list array by ID
        const actualIndex = list.findIndex(item =>
            (item.BoughtOutPartId || item.CostingId) === editRowId
        );

        if (actualIndex === -1) {
            Toaster.error('Unable to update Condition Cost. Row not found.');
            return;
        }

        const oldData = JSON.parse(JSON.stringify(list[actualIndex]));

        // ENHANCEMENT: Store current page and page size before updates
        const savedPage = gridApi ? gridApi.paginationGetCurrentPage() : currentPage;
        const savedPageSize = gridApi ? gridApi.paginationGetPageSize() : currentPageSize;

        // ENHANCEMENT: Save undo state before changes
        saveUndoState(oldData, `Update Condition Cost`);

        list[actualIndex].NewNetConditionCost = totalCostBase;
        list[actualIndex].NewConditionNetCostConversion = totalCostBase;
        list[actualIndex].NewConditionNetCostLocalConversion = totalCostBase;
        list[actualIndex].NewBoughtOutPartConditionsDetails = tableData;

        // Recalculate NewNetLandedCost (Net Cost) = Basic Price + Condition Cost
        list[actualIndex].NewNetLandedCost = preciseAdd(checkForNull(list[actualIndex].NewNetCostWithoutConditionCost), checkForNull(totalCostBase));

        // Update conversion fields
        list[actualIndex].NewNetLandedCostConversion = list[actualIndex].NewNetLandedCost;
        list[actualIndex].NewNetLandedCostLocalConversion = list[actualIndex].NewNetLandedCost;

        // CRITICAL FIX: Update the grid node directly using ID, not index
        const rowId = list[actualIndex]?.BoughtOutPartId || list[actualIndex]?.CostingId;
        const node = findNodeByRowId(rowId);
        if (node) {
            node.setData(list[actualIndex]);
        }

        // Restore pagination
        if (gridApi && savedPage !== undefined) {
            setTimeout(() => {
                gridApi.paginationGoToPage(savedPage);
            }, 0);
        }
    }
    const conditionCostDrawer = (value, row, index, type) => {
        // CRITICAL FIX: Store unique ID instead of index to handle filtering correctly
        const rowId = row?.BoughtOutPartId || row?.CostingId;

        setRowData(row)
        setBasicRate(row?.NewBasicRate)
        setEditRowId(rowId) // Store ID, not index
        setShouldRecalculate(false) // CRITICAL: Don't recalculate when just opening drawer

        if (type === 'Old') {
            setConditionCostDetailForRow(row?.BoughtOutPartConditionsDetails || [])
            setIsViewFlag(true)
        } else {
            setConditionCostDetailForRow(props?.isImpactedMaster ? row?.SimulationBoughtOutPartConditionsDetails || [] : row?.NewBoughtOutPartConditionsDetails || [])
            setIsViewFlag(false)
        }
        setOpenConditionCostDrawer(true)
    }
    const closeOtherCostDrawer = (type, tableData, totalCostCurrency, totalCostBase, RowIndex) => {
        if (type === 'Save') {
            calculateAndSave(tableData, totalCostCurrency)
        } else {
            // If canceling, find the row by ID and revert
            const actualIndex = list.findIndex(item =>
                (item.BoughtOutPartId || item.CostingId) === editRowId
            );
            if (actualIndex !== -1) {
                const originalDetails = list[actualIndex]?.RawMaterialOtherCostDetails || [];
                setOtherCostDetailForRow(originalDetails);
            }
        }
        setOpenOtherCostDrawer(false)
        setIsViewFlag(false)
    }

    const closeConditionCostDrawer = (type, tableData, totalCostCurrency, conditionCost) => {
        if (type === 'save') {
            const newConditionCost = tableData.reduce((acc, item) => preciseAdd(checkForNull(acc), checkForNull(item?.ConditionCostPerQuantity || 0)), 0);
            calculateAndSaveCondition(tableData, newConditionCost)
        } else {
            // If canceling, find the row by ID and revert
            const actualIndex = list.findIndex(item =>
                (item.BoughtOutPartId || item.CostingId) === editRowId
            );
            if (actualIndex !== -1) {
                const originalDetails = list[actualIndex]?.RawMaterialConditionsDetails || [];
                setConditionCostDetailForRow(originalDetails);
            }
        }
        setOpenConditionCostDrawer(false)
        setIsViewFlag(false)
    }
    const existingOtherCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.data; // FIX: Get row data from props.data, not props.valueFormatted

        // REMOVED: beforeSaveCell validation call - formatters should only display, not validate
        // This was causing repeated toaster messages on every render
        const displayValue = cell ? Number(cell) : Number(row?.OtherNetCost);

        return (
            <>
                <span title={displayValue}>
                    {checkForDecimalAndNull(displayValue, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}
                </span>
                {true && <button
                    type="button"
                    className={'View small'}
                    onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'Old')}
                    title="Add"
                >
                </button>}
            </>
        )
    }

    const existingConditionCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.data; // FIX: Get row data from props.data, not props.valueFormatted

        // REMOVED: beforeSaveCell validation call - formatters should only display, not validate
        // This was causing repeated toaster messages on every render

        // ENHANCEMENT: VBC Support - Show "-" for VBC (Vendor Based Costing), show actual value for ZBC (Zero Based Costing)
        const isVendorBased = row?.CostingTypeId === VBCTypeId;
        const displayValue = cell ? Number(cell) : Number(row?.OldNetConditionCost || row?.NetConditionCost);

        return (
            <>
                {
                    isVendorBased ?
                        "-" :
                        <span title={displayValue}>
                            {checkForDecimalAndNull(displayValue, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}
                        </span>
                }
                {!isVendorBased && true && <button
                    type="button"
                    className={'View small'}
                    onClick={() => conditionCostDrawer(cell, row, props.rowIndex, 'Old')}
                    title="Add"
                >
                </button>}
            </>
        )
    }

    const revisedOtherCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.data; // FIX: Get row data from props.data, not props.valueFormatted

        // REMOVED: beforeSaveCell validation call - formatters should only display, not validate
        // This was causing repeated toaster messages on every render
        const displayValue = cell ? Number(cell) : Number(row?.NewOtherNetCost || row?.OtherNetCost);
        const showValue = checkForDecimalAndNull(displayValue, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6);

        setRowIndex(props?.node?.rowIndex)
        return (
            <div className="cell-with-button">
                {
                    props?.isImpactedMaster ?
                        row?.NewOtherCost :
                        <PriceComparisonSpan
                            newValue={Number(row?.NewOtherNetCost || row?.OtherNetCost)}
                            oldValue={Number(row?.OtherNetCost)}
                            costingTypeId={row?.CostingTypeId}
                            className="form-control with-button"
                            title={showValue}
                        >
                            {showValue}
                        </PriceComparisonSpan>
                }
                {/* {!isCostingSimulation && <button */}
                {true && <button
                    type="button"
                    // className={`${(isRunSimulationClicked || isApprovalSummary) ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    //onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'New')}
                    className={`${props?.isImpactedMaster ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'New')}
                    title="Add"
                >
                </button>}
            </div>
        )
    }

    const revisedConditionCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.data; // FIX: Get row data from props.data, not props.valueFormatted

        // REMOVED: beforeSaveCell validation call - formatters should only display, not validate
        // This was causing repeated toaster messages on every render
        const displayValue = cell ? Number(cell) : Number(row?.NewNetConditionCost || row?.NetConditionCost);
        const showValue = checkForDecimalAndNull(displayValue, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6);
        setRowIndex(props?.node?.rowIndex)

        // ENHANCEMENT: VBC Support - Show "-" for VBC (Vendor Based Costing), show actual value for ZBC (Zero Based Costing)
        const isVendorBased = row?.CostingTypeId === VBCTypeId;

        return (
            <>
                {
                    isVendorBased ?
                        "-" :
                        props?.isImpactedMaster ?
                            row?.NewNetConditionCost :
                            <PriceComparisonSpan
                                newValue={Number(row?.NewNetConditionCost || row?.NetConditionCost)}
                                oldValue={Number(row?.NetConditionCost)}
                                costingTypeId={row?.CostingTypeId}
                                className="form-control with-button"
                                title={showValue}
                            >
                                {showValue}
                            </PriceComparisonSpan>
                }
                {/* {!isCostingSimulation && <button */}
                {!isVendorBased && true && <button
                    type="button"
                    // className={`${(isRunSimulationClicked || isApprovalSummary) ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    // onClick={() => ConditionCostDrawer(cell, row, props.rowIndex, 'New')}
                    className={`${props?.isImpactedMaster ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    onClick={() => conditionCostDrawer(cell, row, props.rowIndex, 'New')}
                    title="Add"
                >
                </button>}
            </>
        )
    }

    const localConversionFormatter = (props) => {
        const cellValue = checkForNull(props?.value);
        return checkForDecimalAndNull(cellValue, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)
    }
    const basicPriceRevisedFormatter = (props) => {
        const row = props?.data;

        // Calculate the new basic price (basic rate + other costs) / NumberOfPieces
        const NumberOfPieces = getConfigurationKey().IsMinimumOrderQuantityVisible ? Number(row?.NumberOfPieces) : 1;

        // Calculate old basic price
        const oldBasicPrice = preciseDivide(preciseAdd(Number(row.BasicRate), checkForNull(row?.OtherNetCost)), NumberOfPieces);

        // Calculate new basic rate based on percentage or direct entry
        let newBasicRate = 0;
        let isPercentageApplied = (row?.Percentage !== '') && (checkForNull(row?.Percentage) !== 0) && checkForNull(row?.Percentage) <= 100;

        if (isPercentageApplied) {
            // When percentage is applied, calculate the new basic rate
            newBasicRate = preciseAdd(row.BasicRate, preciseDivide(preciseMultiply(row.BasicRate, row.Percentage), 100));
        } else {
            // When direct entry is used
            newBasicRate = props?.isImpactedMaster ? row.NewBOPRate : (row.NewBasicRate || row.BasicRate);
        }

        const newOtherCost = props?.isImpactedMaster ? row.NewOtherCost : (row.NewOtherNetCost || row.OtherNetCost);
        const newBasicPrice = props?.isImpactedMaster ? row?.NewNetCostWithoutConditionCost : preciseDivide(preciseAdd(checkForNull(newBasicRate), checkForNull(newOtherCost)), NumberOfPieces);

        const decimalPlaces = isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6;
        const displayValue = checkForDecimalAndNull(newBasicPrice, decimalPlaces);

        return (
            <div className='ag-header-cell-label'>
                <PriceComparisonSpan
                    newValue={newBasicPrice}
                    oldValue={oldBasicPrice}
                    costingTypeId={row?.CostingTypeId}
                    title={displayValue}
                >
                    {displayValue}
                </PriceComparisonSpan>
            </div>
        );
    };

    const hyphenFormatter = (props) => {
        const cellValue = props?.value;
        return (cellValue !== ' ' && cellValue !== null && cellValue !== '' && cellValue !== undefined) ? cellValue : '-';
    }

    const frameworkComponents = {
        effectiveDateRenderer: effectiveDateFormatter,
        costingHeadFormatter: costingHeadFormatter,
        NewcostFormatter: NewcostFormatter,
        OldcostFormatter: OldcostFormatter,
        costFormatter: costFormatter,
        customNoRowsOverlay: NoContentFound,
        cellChange: cellChange,
        oldBasicRateFormatter: oldBasicRateFormatter,
        vendorFormatter: vendorFormatter,
        plantFormatter: plantFormatter,
        customerFormatter: customerFormatter,
        revisedBasicRateHeader: revisedBasicRateHeader,
        percentageFormatter: percentageFormatter,
        ageValueGetter: ageValueGetter,
        ageValueGetterPer: ageValueGetterPer,
        newBasicRateFormatter: newBasicRateFormatter,
        existingOtherCostFormatter: existingOtherCostFormatter,
        revisedOtherCostFormatter: revisedOtherCostFormatter,
        existingConditionCostFormatter: existingConditionCostFormatter,
        revisedConditionCostFormatter: revisedConditionCostFormatter,
        basicPriceRevisedFormatter: basicPriceRevisedFormatter,
        localConversionFormatter: localConversionFormatter,
        hyphenFormatter: hyphenFormatter
    };

    const basicRatetooltipToggle = () => {
        setBasicRateViewTooltip(!basicRateviewTooltip)
    }
    const scrapRatetooltipToggle = () => {
        setScrapRateViewTooltip(!scrapRateviewTooltip)
    }

    const onBtExport = () => {
        return returnExcelColumn(BOP_IMPACT_DOWNLOAD_EXCEL_NON_ASSOCIATED, list)
    };

    const returnExcelColumn = (data = [], TempData) => {

        let temp = []
        TempData && TempData.map((item) => {
            item.EffectiveDate = (item?.EffectiveDate)?.slice(0, 10)
            if (item?.NewNetLandedCostConversion === null || item?.NewNetLandedCostConversion === undefined) {
                item.NewNetLandedCostConversion = item?.OriginalNetLandedCost
            }
            if (item?.NewNetCostWithoutConditionCost === null || item?.NewNetCostWithoutConditionCost === undefined || item?.NewNetCostWithoutConditionCost === 0) {
                item.NewNetCostWithoutConditionCost = item?.NewBasicRate
            }

            if (!item?.IsBOPAssociated) {
                item.OriginalNetLandedCost = item?.NetLandedCost
                item.NewNetLandedCostConversion = item?.NewNetLandedCost
            } else {
                item.OriginalNetLandedCost = item?.OldNetLandedCost
                item.NewNetLandedCostConversion = item?.NewNetLandedCostConversion === "-" ? item?.OriginalNetLandedCost : item?.NewNetLandedCostConversion
            }

            Object.keys(item)?.forEach(key => {
                if (item[key] === null || item[key] === undefined || item[key] === '') {
                    item[key] = "-";
                }
            });

            temp.push(item)
        })

        if (getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && TempData[0]?.CostingTypeId !== ZBCTypeId) {
            data = data?.filter(
                col => col.value !== "NetConditionCost" && col.value !== "NewNetConditionCost" && col.value !== "NewNetCostWithoutConditionCost" && col.value !== "NetCostWithoutConditionCost"
            );
        }
        return (
            <ExcelSheet data={temp} name={`${showBopLabel()} Data`}>
                {data && data.map((ele, index) => <ExcelColumn key={index} label={ele.label} value={ele.value} style={ele.style} />)}
            </ExcelSheet>);
    }

    return (

        <div>
            <div className={`ag-grid-react`}>
                {!showverifyPage &&
                    <Fragment>
                        {showTooltip && !props?.sImpactedMaster && <Tooltip className="rfq-tooltip-left" placement={"top"} isOpen={basicRateviewTooltip} toggle={basicRatetooltipToggle} target={"basicRate-tooltip"} >{"To edit revised basic rate please double click on the field."}</Tooltip>}
                        {/* {showTooltip && !props?.isImpactedMaster && <Tooltip className="rfq-tooltip-left" placement={"top"} isOpen={scrapRateviewTooltip} toggle={scrapRatetooltipToggle} target={"scrapRate-tooltip"} >{"To edit revised scrap rate please double click on the field."}</Tooltip>} */}


                        <Row>
                            <Col className={`add-min-height mb-3 sm-edit-page  ${(list && list?.length <= 0) || noData ? "overlay-contain" : ""}`}>
                                <div className="ag-grid-wrapper height-width-wrapper">
                                    <div className="ag-grid-header d-flex align-items-center justify-content-between">
                                        <div className='d-flex align-items-center'>
                                            <input type="text" className="form-control table-search" id="filter-text-box" placeholder="Search " autoComplete={'off'} onChange={(e) => onFilterTextBoxChanged(e)} />
                                            <button type="button" className="user-btn float-right mr-2" title="Reset Grid" onClick={() => resetState()}>
                                                <div className="refresh mr-0"></div>
                                            </button>
                                            <ExcelFile filename={'Impacted Master Data'} fileExtension={'.xls'} element={
                                                <button title="Download" type="button" className={'user-btn'} ><div className="download mr-0"></div></button>}>
                                                {onBtExport()}
                                            </ExcelFile>
                                        </div>
                                        <div className='d-flex justify-content-end bulk-upload-row pr-0 zindex-2'>
                                            {
                                                isbulkUpload && <>
                                                    <div className="d-flex align-items-center">
                                                        <label>Rows with changes:</label>
                                                        <TextFieldHookForm
                                                            label=""
                                                            name={'NoOfCorrectRow'}
                                                            Controller={Controller}
                                                            title={titleObj.rowWithChanges}
                                                            control={control}
                                                            register={register}
                                                            rules={{ required: false }}
                                                            mandatory={false}
                                                            handleChange={() => { }}
                                                            defaultValue={''}
                                                            className=""
                                                            customClassName={'withBorder mn-height-auto hide-label mb-0'}
                                                            errors={errors.NoOfCorrectRow}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <label>Rows without changes:</label>
                                                        <TextFieldHookForm
                                                            label=""
                                                            name={'NoOfRowsWithoutChange'}
                                                            title={titleObj.rowWithoutChanges}
                                                            Controller={Controller}
                                                            control={control}
                                                            register={register}
                                                            rules={{ required: false }}
                                                            mandatory={false}
                                                            handleChange={() => { }}
                                                            defaultValue={''}
                                                            className=""
                                                            customClassName={'withBorder mn-height-auto hide-label mb-0'}
                                                            errors={errors.NoOfRowsWithoutChange}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </>
                                            }
                                            <div className={`d-flex align-items-center simulation-label-container`}>
                                                {/* ENHANCEMENT: Undo UI Component - Using common component */}
                                                <UndoButton
                                                    undoCount={undoCount}
                                                    onUndo={handleUndo}
                                                    disabled={!canUndo}
                                                    position="right"
                                                />
                                                <RedoButton
                                                    redoCount={redoCount}
                                                    onRedo={handleRedo}
                                                    disabled={!canRedo}
                                                    position="right"
                                                />
                                                {list[0].CostingTypeId !== CBCTypeId && <div className='d-flex pl-3'>
                                                    <label className='mr-1'>{vendorLabel} (Code):</label>
                                                    <p title={list[0].Vendor} className='mr-2'>{list[0].Vendor ? list[0].Vendor : list[0]['Vendor (Code)']}</p>
                                                </div>}
                                                <button type="button" id="simulation-back" className={"apply back_simulationPage"} onClick={cancel}> <div className={'back-icon'}></div>Back</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ag-theme-material p-relative" style={{ width: '100%' }}>
                                        {noData && <NoContentFound title={EMPTY_DATA} customClassName="no-content-found simulation-lisitng" />}
                                        {list &&
                                            (render || isLoader ? <LoaderCustom customClass="loader-center" /> : (<AgGridReact
                                                ref={gridRef}
                                                getRowNodeId={getRowNodeId}
                                                style={{ height: '100%', width: '100%' }}
                                                defaultColDef={defaultColDef}
                                                domLayout='autoHeight'
                                                floatingFilter={true}
                                                rowData={list}
                                                getRowId={(params) => params.data.BoughtOutPartId || params.data.CostingId}
                                                pagination={true}
                                                paginationPageSize={defaultPageSize}
                                                onGridReady={onGridReady}
                                                gridOptions={gridOptions}
                                                loadingOverlayComponent={'customLoadingOverlay'}
                                                noRowsOverlayComponent={'customNoRowsOverlay'}
                                                noRowsOverlayComponentParams={{
                                                    title: EMPTY_DATA,
                                                }}
                                                frameworkComponents={frameworkComponents}
                                                suppressColumnVirtualisation={true}
                                                stopEditingWhenCellsLoseFocus={true}
                                                onFilterModified={onFloatingFilterChanged}
                                                enableBrowserTooltips={true}
                                                onCellValueChanged={onCellValueChanged}
                                            >
                                                {/* <AgGridColumn field="Technologies" editable='false' headerName="Technology" minWidth={190}></AgGridColumn> */}
                                                <AgGridColumn minWidth={140} field="CostingHead" tooltipField='CostingHead' headerName="Costing Head" editable='false' cellRenderer={'costingHeadFormatter'}></AgGridColumn>
                                                {<AgGridColumn field="EntryType" minWidth={120} headerName="Entry Type" editable='false' cellRenderer={"hyphenFormatter"}></AgGridColumn>}
                                                <AgGridColumn field="BoughtOutPartNumber" tooltipField='BoughtOutPartNumber' editable='false' headerName={`${showBopLabel()} Part No.`} minWidth={columnWidths?.BoughtOutPartNumber}></AgGridColumn>
                                                <AgGridColumn field="BoughtOutPartName" tooltipField='BoughtOutPartName' editable='false' headerName={`${showBopLabel()} Part Name`} minWidth={columnWidths?.BoughtOutPartNumber}></AgGridColumn>
                                                {<AgGridColumn field="BoughtOutPartCategory" tooltipField='BoughtOutPartCategory' editable='false' headerName={`${showBopLabel()} Part Category`} minWidth={columnWidths?.BoughtOutPartCategory}></AgGridColumn>}
                                                {list[0].CostingTypeId !== CBCTypeId && <AgGridColumn field="Vendor" tooltipField='Vendor' editable='false' headerName={vendorLabel + " (Code)"} minWidth={columnWidths?.Vendor} cellRenderer='vendorFormatter'></AgGridColumn>}
                                                {list[0].CostingTypeId === CBCTypeId && <AgGridColumn field="CustomerName" tooltipField='CustomerName' editable='false' headerName="Customer (Code)" minWidth={columnWidths?.CustomerName} cellRenderer='customerFormatter'></AgGridColumn>}
                                                {<AgGridColumn field="Plants" tooltipField='Plants' editable='false' headerName="Plant (Code)" minWidth={columnWidths?.Plants} cellRenderer='plantFormatter'></AgGridColumn>}
                                                {getConfigurationKey().IsMinimumOrderQuantityVisible && <AgGridColumn field="NumberOfPieces" tooltipField='NumberOfPieces' editable='false' headerName="Min Order Quantity" minWidth={columnWidths?.NumberOfPieces} ></AgGridColumn>}
                                                {getConfigurationKey().IsSourceExchangeRateNameVisible && <AgGridColumn minWidth={120} field="ExchangeRateSourceName" headerName="Exchange Rate Source" editable='false'></AgGridColumn>}
                                                {<AgGridColumn field="Currency" minWidth={180} tooltipField='Currency' editable='false' headerName="Currency/Settlement Currency"></AgGridColumn>}

                                                <AgGridColumn field="LocalCurrency" minWidth={120} headerName={"Plant Currency"} cellRenderer={"currencyFormatter"} editable='false'></AgGridColumn>
                                                <AgGridColumn headerClass="justify-content-center" cellClass="text-center" headerName={`Basic Rate (Currency)`} marryChildren={true} width={columnWidths?.BasicRate.group} suppressSizeToFit={true} pinned='right'>
                                                    <AgGridColumn width={columnWidths?.BasicRate.existing} field="BasicRate" editable='false' cellRenderer='oldBasicRateFormatter' headerName="Existing" colId="BasicRate" suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.BasicRate.revised} cellRenderer='newBasicRateFormatter' editable={EditableCallbackForBasicRate} onCellValueChanged='cellChange' field="NewBasicRate" valueGetter={ageValueGetter} headerName="Revised" colId='NewBasicRate' headerComponent={'revisedBasicRateHeader'} suppressSizeToFit={true} pinned='right' valueSetter={(params) => {
                                                        // Use the validation-enabled value setter
                                                        return valueSetter(params, 'basicRate');
                                                    }}></AgGridColumn>
                                                </AgGridColumn>
                                                {<AgGridColumn width={columnWidths?.Percentage} editable={EditableCallbackForPercentage} onCellValueChanged='cellChange' field="Percentage" colId='Percentage' valueGetter={ageValueGetterPer} cellRenderer='percentageFormatter' pinned='right' valueSetter={(params) => {
                                                    // Use the validation-enabled value setter
                                                    return valueSetter(params, 'percentage');
                                                }}></AgGridColumn>}
                                                <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.OtherCost.group} headerName={
                                                    "Other Cost (Currency)"
                                                } marryChildren={true} suppressSizeToFit={true} pinned='right'>
                                                    <AgGridColumn width={columnWidths?.OtherCost.existing} cellRenderer='existingOtherCostFormatter' field=" OtherNetCost" editable='false' headerName="Existing" /* colId={ "OtherNetCost"} */ suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.OtherCost.revised} cellRenderer='revisedOtherCostFormatter' editable={false} onCellValueChanged='cellChange' field="NewOtherNetCost" headerName="Revised" colId='NewOtherNetCost' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                </AgGridColumn>
                                                {getConfigurationKey().IsBasicRateAndCostingConditionVisible && list[0]?.CostingTypeId === ZBCTypeId && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.BasicPrice.group} headerName={
                                                    "Basic Price (Currency)"
                                                } suppressSizeToFit={true} marryChildren={true} pinned='right'>
                                                    <AgGridColumn width={columnWidths?.NetCostWithoutConditionCost} field='NetCostWithoutConditionCost' editable='false' headerName="Existing" colId='NetCostWithoutConditionCost' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.NewNetCostWithoutConditionCost} field="NewNetCostWithoutConditionCost" editable='false' headerName="Revised" cellRenderer='basicPriceRevisedFormatter' colId='NewNetCostWithoutConditionCost' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                </AgGridColumn>}

                                                {getConfigurationKey().IsBasicRateAndCostingConditionVisible && shouldShowConditionCostColumn && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.ConditionCost.group} headerName={
                                                    "Condition Cost (Currency)"

                                                } marryChildren={true} suppressSizeToFit={true} pinned='right'>

                                                    <AgGridColumn width={columnWidths?.ConditionCost.existing} cellRenderer='existingConditionCostFormatter' field={"NetConditionCost"} editable='false' headerName="Existing" colId={"NetConditionCost"} suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.ConditionCost.revised} cellRenderer='revisedConditionCostFormatter' editable={false} onCellValueChanged='cellChange' field={"NewNetConditionCost"} headerName="Revised" colId='NewNetConditionCost' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                </AgGridColumn>}
                                                <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.NetCost.group} headerName={`Net Cost (Currency)`} marryChildren={true} suppressSizeToFit={true} pinned='right'>
                                                    {/* <AgGridColumn minWidth={120} field="OldNetLandedCost" editable='false' cellRenderer={'OldcostFormatter'} headerName="Old" colId='NetLandedCost'></AgGridColumn>} */}
                                                    <AgGridColumn width={columnWidths?.NetCost.existing} field="OldNetLandedCost" editable='false' cellRenderer={'OldcostFormatter'} headerName="Existing" colId='NetLandedCost' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.NetCost.revised} field="NewNetLandedCost" editable='false' cellRenderer={'NewcostFormatter'} headerName="Revised" valueGetter={ageValueGetterLanded} colId='NewNetLandedCost' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                </AgGridColumn>
                                                {(String(props?.masterId) === String(RMIMPORT) || String(props?.masterId) === String(EXCHNAGERATE)) && <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.PlantCurrency.group} headerName={
                                                    "Net Cost (Plant Currency)"

                                                } suppressSizeToFit={true} marryChildren={true} pinned='right'>
                                                    <AgGridColumn width={columnWidths?.PlantCurrency.existing} field="OldNetLandedCostLocalConversion" editable='false' headerName="Existing" colId='OldNetLandedCostLocalConversion' cellRenderer='localConversionFormatter' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                    <AgGridColumn width={columnWidths?.PlantCurrency.revised} field="NewNetLandedCostLocalConversion" editable='false' valueGetter={ageValueGetterLanded} headerName="Revised" colId='NewNetLandedCostLocalConversion' cellRenderer='localConversionFormatter' suppressSizeToFit={true} pinned='right'></AgGridColumn>
                                                </AgGridColumn>
                                                }

                                                <AgGridColumn field="EffectiveDate" headerName={props.isImpactedMaster && !props.lastRevision ? "Current Effective date" : "Effective Date"} editable='false' minWidth={columnWidths?.EffectiveDate} cellRenderer='effectiveDateRenderer'></AgGridColumn>
                                                <AgGridColumn field="CostingId" hide={true}></AgGridColumn>


                                            </AgGridReact>))}

                                        {<PaginationWrapper gridApi={gridApi} setPage={onPageSizeChanged} />}
                                    </div>
                                </div>

                            </Col>
                        </Row>
                        {true &&
                            <Row className="sf-btn-footer no-gutters justify-content-between bottom-footer">
                                <div className="col-sm-12 text-right bluefooter-butn d-flex justify-content-end align-items-center">
                                    <div className="inputbox date-section mr-3 verfiy-page simulation_effectiveDate">
                                        <DatePicker
                                            name="EffectiveDate"
                                            id="EffectiveDate"
                                            selected={DayTime(effectiveDate).isValid() ? new Date(effectiveDate) : ''}
                                            onChange={handleEffectiveDateChange}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode='select'
                                            dateFormat="dd/MM/yyyy"
                                            minDate={maxDate}
                                            placeholderText="Select effective date"
                                            className="withBorder"
                                            autoComplete={"off"}
                                            disabledKeyboardNavigation
                                            onChangeRaw={(e) => e.preventDefault()}
                                        />
                                        {isWarningMessageShow && <WarningMessage dClass={"error-message"} textClass={"pt-1"} message={"Please select effective date"} />}
                                    </div>
                                    <button
                                        onClick={verifySimulation}
                                        type="submit"
                                        id="verify-btn"
                                        className="user-btn mr5 save-btn verifySimulation"
                                        disabled={isDisable || !isEffectiveDateSelected}
                                        title={
                                            isDisable ? "Simulation is running..." :
                                                !isEffectiveDateSelected ? "Please select an effective date" :
                                                    "Click to verify simulation"
                                        }
                                    >
                                        <div className={"Run-icon"}>
                                        </div>{" "}
                                        {"Verify"}
                                    </button>
                                    {/* <button onClick={runSimulation} type="submit" className="user-btn mr5 save-btn"                    >
                                <div className={"Run"}>
                                </div>{" "}
                                {"RUN SIMULATION"}
                            </button> */}
                                </div>
                            </Row>
                        }
                    </Fragment>

                }
                {
                    showverifyPage &&
                    <VerifySimulation token={token} cancelVerifyPage={cancelVerifyPage} />
                }

                {
                    showRunSimulationDrawer &&
                    <RunSimulationDrawer
                        isOpen={showRunSimulationDrawer}
                        closeDrawer={closeDrawer}
                        anchor={"right"}
                    />
                }
                {
                    openOtherCostDrawer &&
                    <AddOtherCostDrawer
                        isOpen={openOtherCostDrawer}
                        anchor={"right"}
                        closeDrawer={closeOtherCostDrawer}
                        rawMaterial={true}
                        rmBasicRate={basicRate}
                        ViewMode={isViewFlag}
                        rmTableData={otherCostDetailForRow}
                        RowData={rowData}
                        plantCurrency={rowData?.LocalCurrency}
                        settlementCurrency={rowData?.Currency}
                        isBOP={true}
                        disabled={props?.isImpactedMaster}
                    />
                }
                {
                    getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && openConditionCostDrawer &&
                    <AddConditionCosting
                        isOpen={openConditionCostDrawer}
                        tableData={conditionCostDetailForRow}
                        closeDrawer={closeConditionCostDrawer}
                        anchor={'right'}
                        basicRateBase={netCostWithoutConditionCost}
                        ViewMode={isViewFlag}
                        isFromMaster={true}
                        // isFromImport={states.isImport}
                        // EntryType={checkForNull(ENTRY_TYPE_DOMESTIC)}
                        currency={rowData?.Currency}
                        PlantCurrency={rowData?.LocalCurrency}
                        isBOP={true}
                        disabled={props?.isImpactedMaster}
                    />
                }
            </div>
        </div>
    );
}


export default BDNonAssociatedSimulation;